import React from "react";
import "./reset.css";
import "./App.css";
import { getDamageReductionPercent } from "./utils";

function App() {
  const [screen, setScreen] = React.useState("home");
  const titles = {
    home: "L2 Tool",
    damagePenalty: "Расчёт снижения урона",
    PMWeaponDamage: "Бонус атаки оружием",
  };
  const [playerLevel, setPlayerLevel] = React.useState("");
  const [monsterLevel, setMonsterLevel] = React.useState("");
  const [result, setResult] = React.useState(null);

  function reduceDamageCalc() {
    const pLvl = Number(playerLevel);
    const mLvl = Number(monsterLevel);

    if (!pLvl || !mLvl) {
      setResult("Введите оба уровня");
      return;
    }
    const penalty = getDamageReductionPercent(mLvl, pLvl);
    if (penalty === 0) {
      setResult("Снижения урона не будет");
      return;
    }
    setResult(`Снижение урона на ${penalty.toFixed(2)}%`);
  }

  return (
    <div className="container">
      <div className="app">
        <header className="header">
          {screen !== "home" && (
            <button className="back-button" onClick={() => setScreen("home")}>
              <img src="/img/arrow-back.png" alt="Назад" />
            </button>
          )}
          <h1 className="title">{titles[screen]}</h1>
        </header>
        <main className="main">
          {screen === "home" && (
            <>
              <div className="menu">
                <div className="menu-item">
                  <button
                    className="button"
                    onClick={() => setScreen("damagePenalty")}
                  >
                    Штраф урона
                  </button>
                  <div className="description">
                    Рассчитывается снижение урона в зависимости от разницы в
                    уровне.
                  </div>
                </div>

                <div className="menu-item">
                  <button
                    className="button"
                    onClick={() => setScreen("PMWeaponDamage")}
                  >
                    Атака оружием
                  </button>
                  <div className="description">
                    Определяется прибавка к урону в зависимости от прибавки
                    атаки оружием.
                  </div>
                </div>
              </div>
            </>
          )}

          {screen === "damagePenalty" && (
            <>
              <div className="form">
                <label>
                  Уровень персонажа:{" "}
                  <input
                    type="number"
                    value={playerLevel}
                    onChange={(e) => setPlayerLevel(e.target.value)}
                  />
                </label>
                <label>
                  Уровень монстра:{" "}
                  <input
                    type="number"
                    value={monsterLevel}
                    onChange={(e) => setMonsterLevel(e.target.value)}
                  />
                </label>
              </div>
              <div className="buttons">
                <button className="button" onClick={reduceDamageCalc}>
                  Рассчитать
                </button>
              </div>
              <div className="result">{result}</div>
            </>
          )}

          {screen === "PMWeaponDamage" && (
            <>
              <div className="form">
                <label>
                  Было атаки: <input type="number" />
                </label>
                <label>
                  Стало атаки: <input type="number" />
                </label>
              </div>
              <div className="buttons">
                <button className="button">Рассчитать</button>
              </div>
              <div className="result">{"Result"}</div>
            </>
          )}
        </main>
        <footer className="footer">© 2026 L2 Tool created by Вильтор</footer>
      </div>
    </div>
  );
}

export default App;
